import {Core} from '@strapi/strapi';
import {KoniBotServiceType} from "./koni-bot";
import {TelegramUserServiceType} from "../content-type/telegram-user";
import {BotBasicActionType} from "./basic-actions";
import {BotMessageTemplateType} from "../content-type/bot-message-template";

const KoniBotAction = ({strapi}: { strapi: Core.Strapi }) => ({
  koniBot: strapi.plugin('telegram-bot').service<KoniBotServiceType>('koniBot'),
  botTemplate: strapi.plugin('telegram-bot').service<BotMessageTemplateType>('bot-message-template'),
  telegramUser: strapi.plugin('telegram-bot').service<TelegramUserServiceType>('telegramUser'),
  async registerBotActions() {
    strapi.log.info('[Telegram Bot] Registering bot actions');
    const botMap = this.koniBot.botMap;
    const basicBotAction = strapi.plugin('telegram-bot').service<BotBasicActionType>('botBasicAction');

    // Handle action for multiple bot
    for (const [key, botHandler] of Object.entries(botMap)) {
      const bot = botHandler.bot;
      bot.command('start', basicBotAction.handleStart.bind(basicBotAction));
      bot.command('help', basicBotAction.handleHelp.bind(basicBotAction));

      const existed = await bot.telegram.getMyCommands();
      const commands = [
        ...existed,
        {command: 'start', description: 'Start Bot'},
        {command: 'help', description: 'Show help'},
      ];

      await bot.telegram.setMyCommands(commands);
      bot.on('message', basicBotAction.handleMessage.bind(basicBotAction));
      strapi.log.info(`[Telegram Bot | ${key}] Registering bot actions done`);
    }
  },
});

export type KoniBotActionType = ReturnType<typeof KoniBotAction>;
export default KoniBotAction;
